<div class="card-toolbar d-flex justify-content-end">
    <button class="btn btn-primary mr-2" color="accent" (click)="onCreate()">{{ 'addSubscription' | translate }}</button>
</div>
<app-subscriptions-accordion [pagedResult]="pagedResult$ | async" [currentLang]="currentLang"
    (pageChangeEvent)="pageChanged($event)" (editEvent)="edit($event)" (deleteEvent)="delete($event)">
</app-subscriptions-accordion>